// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n7-0";
export var animationContainer = "_n7-1";
export var itemPrice = "_n7-a";
export var itemizedContent = "_n7-9";
export var itemizedHeader = "_n7-7";
export var itemizedRow = "_n7-8";
export var itemizedSection = "_n7-6";
export var modalContent = "_n7-2";
export var orderName = "_n7-3";
export var refundOption = "_n7-4";
export var refundOptionsContainer = "_n7-5";
export var shippingLabel = "_n7-b";
export var totalRow = "_n7-c";